import { React } from 'Imports';
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AgreementsService, IAgreementsServiceInjectedProps } from '$State/AgreementsFreezerService';
import { IntegrationPartnerDataService } from '$State/IntegrationPartnerDataFreezerService';
import { CircularProgress } from 'MaterialUIComponents';
import { TermsOfUseModal } from '$Components/TermsOfUse/TermsOfUseModal';

type IRequiredAgreementsProps = IAgreementsServiceInjectedProps;

const _RequiredAgreements = (props: IRequiredAgreementsProps) => {
    const { signedAgreementsResults } = props.agreements.getState();
    const { data: signedAgreement, isFetching, error } = signedAgreementsResults;

    const initialShouldShowModal = (() => {
        const showAgreements = props.agreements.getShowAgreements();
        if (!showAgreements) return false;
        if (signedAgreement) return !signedAgreement.matches || !!error;
        if (error) return true;
        return false;
    })();
    const [shouldShowModal, setShouldShowModal] = useState(initialShouldShowModal);

    useEffect(() => {
        const showAgreements = props.agreements.getShowAgreements();
        if (!showAgreements) {
            setShouldShowModal(false);
            return;
        }
        if (signedAgreement) {
            setShouldShowModal(!signedAgreement.matches || !!error);
        } else if (error) {
            setShouldShowModal(true);
        }
    }, [signedAgreement, error, props.agreements]);

    if (!props.agreements.getShowAgreements()) {
        return <Outlet />;
    }

    // While fetching initial data, show only a spinner.
    if (isFetching && !signedAgreement) {
        return <CircularProgress />;
    }

    if (shouldShowModal) {
        return <TermsOfUseModal />;
    }

    // Only render Outlet if checks are complete and passed.
    return <Outlet />;
};

const RequiredAgreements = AgreementsService.inject(_RequiredAgreements);

export default RequiredAgreements;
